import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

import { trackEvent } from '@/helpers/heap/trackEvent';

import { IconArrowRight } from '@/components/icons';
import { SavedCitation } from '../SearchBox';

type CitationsProps = {
	testId?: string;
	attribution: SavedCitation;
};

const Citations = (props: CitationsProps) => {
	const { attribution, testId = 'Citations' } = props;

	// TODO: Analyze the new citations according to the responses and improve this component
	const attributionFromURL = attribution.uri
		.replace('https://www.hvac.com/', '')
		.split('/');

	// Since the response from SDK don't give us the actual page title, this will help us to extract it
	// and create labels and pills.
	const urlElements = attributionFromURL.filter((el) => el !== '');
	const citationText = urlElements.slice(-1)[0] || '';

	let pillText: string | undefined = undefined;

	if (
		attribution.uri.includes('/blog/') ||
		attribution.uri.includes('/expert-advice/')
	) {
		pillText = 'Expert Advice';
	}

	if (attribution.uri.includes('/tools/')) {
		pillText = 'Tools';
	}

	if (
		attribution.uri.includes('repair') ||
		attribution.uri.includes('replace')
	) {
		pillText = 'Repair & Replace';
	}

	const handleCitationClick = () => {
		trackEvent('AI Citation Clicked', {
			'Citation URL': attribution.uri,
			'Citation Text Preview': attribution.text.substring(0, 50), // Logs the first 50 characters of the citation text to help analyze user behavior and understand what part of the text influenced their decision to click.
		});
	};

	return (
		<div data-testid={testId} className="flex flex-col items-center gap-2">
			<div className="group w-full rounded-3xl bg-white p-5">
				<div className="flex flex-col">
					<Link
						href={attribution.uri}
						onClick={handleCitationClick}
						className="flex flex-col items-start text-sm font-normal text-amber-700 group-hover:text-amber-800"
					>
						{pillText && (
							<div
								className={cn(
									'mb-3 flex h-6 max-w-fit items-center rounded-md px-2 py-1 text-sm lg:h-7',
									'bg-sky-50 font-medium text-sky-700',
								)}
							>
								{pillText}
							</div>
						)}
						<div className="px-3">
							{attribution.text !== '' && (
								<p className="mb-4 line-clamp-2 text-ellipsis text-xs">
									{attribution.text}
								</p>
							)}
							<div className="flex items-center">
								<span>
									{`${citationText.charAt(0).toUpperCase()}${citationText
										.slice(1)
										.replace(/-/g, ' ')}`}
								</span>
								<IconArrowRight className="ml-1 w-3 fill-amber-700 group-hover:fill-amber-800" />
							</div>
						</div>
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Citations;
